import { NumberFieldView } from '../numberField/views';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReadingMethod } from '../constants';

export const OilQualityFieldView = NumberFieldView.extend({
    template: '#tpl_oil_quality_field',
    model: null, // MobileOilQualityField

    templateHelpers: function () {
        const acceptanceValue = this.model.get('acceptance_value');
        let placeholderText = 'TPM';

        return $.extend(
            {
                acceptance_value_class: this.model.get('value') ? this.getAcceptanceCriteriaClass(acceptanceValue) : '',
                show_validation_message: this.showValidationMessage(acceptanceValue),
                value: this.model.get('value'),
                placeholder_text: _t(placeholderText) || placeholderText
            },
            OilQualityFieldView.__super__.templateHelpers.apply(this, arguments)
        );
    },

    onRender: function () {
        // mounts mui icons
        if (this.model.get('acceptance_value') === -1) {
            const elem = this.$('.failure-alert')[0];
            window.mountReactJSX(elem, () => <ErrorOutlineIcon />);
        }
    },

    getAcceptanceCriteriaClass: function (acceptanceValue) {
        if (acceptanceValue === -1) {
            return 'failure';
        }

        if (acceptanceValue === 0) {
            return 'warning';
        }

        return 'neutral';
    },

    showValidationMessage: function (acceptanceValue) {
        if (acceptanceValue <= 0) return true;

        return false;
    },

    save_value: function (event) {
        // remove commas from input before saving
        event.target.value = event.target.value.replace(/,/g, '');
        this.fix_event_val_leading_decimal(event);

        const input = $(event.target).val();
        this.$el.removeClass('invalid');
        this.model.set({ value: input, reading_method: ReadingMethod.MANUAL });

        if (input != this.model.get('value')) {
            // rounded_value may be the same as value, so a change is not triggered but
            // the input value needs to be updated to show just 2 decimals
            this.render();
        }
    },

    setValue: function (value, readingMethod) {
        if (!value) {
            return;
        }

        this._scroll_down_one_field();
        this.model.set({ value: value, reading_method: readingMethod });
        this.pollStop();
    },

    /**
     * Move to the next visible field upon entering a value. So if this field generates a dependent text field, do nothing.
     *
     * Move to to the next visible field ONLY IF:
     *  - it is a oil quality field
     *  - and it has not been previously answered
     */
    on_change_action: function (model) {
        // Ensure the action is setting a new temperature, not clearing an existing one as well.
        if (model.changed.value === null) {
            return;
        }

        var next_model = model.get_next_visible();
        // Note: if an answer has been answered and then cleared it is null, but if it has never been touched,
        // the value is ""
        if (
            !next_model ||
            next_model.get('type') != 'oil_quality' ||
            ['', null].indexOf(next_model.get('value')) == -1
        ) {
            return;
        }

        var $target = $('#field_' + next_model.get('id'));
        if (!$target) {
            return;
        }
        var $input = $target.find('.fake_input');
        if (!$input) {
            return;
        }
        $input.focus().click();
        // after this sets a value, the delete box comes up which changes the height of the current element,
        // by delaying shortly we move down the full height of this element
        setTimeout(this._scroll_down_one_field.bind(this), 100);
    }
});
